export default "__VITE_ASSET__BvTQrkOh__"